/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto as DigiworkMaitreDPosDtoEmployeeEmployeeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';

export interface ListAllEmployeesForVenue$Params {
  VenueId?: string;
  SelectedDate?: string;
}

export function listAllEmployeesForVenue(http: HttpClient, rootUrl: string, params?: ListAllEmployeesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>> {
  const rb = new RequestBuilder(rootUrl, listAllEmployeesForVenue.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('SelectedDate', params.SelectedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>;
    })
  );
}

listAllEmployeesForVenue.PATH = '/api/mng/Employee/listallemployeesforvenue';
